import React from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import api from '../../../../components/api';

interface Schedule {
  cancel: number | null
  date: string
  id: number
  masterScheduleId: number | null
  name: string
  numberOfClients: number | null
  status?: number | null
  user: {
    company: string | null
    deleteDate: string | null
    deleted: boolean | null
    firstname: string
    id: number
    lastname: string
    phoneNumber: string
    position: string | null
    username: string | null
  }
}

interface MyFormValueType {
  id: number;
  vmId: number[];
  sendEmail: boolean;
  sendSMS: boolean;
}

function useScheduled(selectedDate: {start : string, end: string}) {
  const [currentPage, setCurrentPage] = React.useState(0);
  const onNextPage = () => setCurrentPage(currentPage + 1);
  const onPreviousPage = () => {
    if (currentPage !== 1)setCurrentPage(currentPage - 1);
  };

  const { data, isLoading, refetch } = useQuery(
    ['getByDateRange', 'schedules', selectedDate.start, selectedDate.end, currentPage, 10],
    () => api.schedules.getByDateRange(selectedDate.start, selectedDate.end, currentPage, 10),
  );

  React.useEffect(() => {
    refetch().catch((e) => alert(e.message));
  }, [selectedDate, currentPage]);

  const navigate = useNavigate();
  const onNavigateEditSchedule = (id: string | number) => navigate(`/routes/schedule/add/${id}`);

  const [resData, setResData] = React.useState<Schedule[] | undefined>(undefined);
  const [arrayOfShow, setArrayOfShow] = React.useState<boolean[]>([]);

  React.useEffect(() => {
    if (data?.data?.data) {
      setResData(data.data.data);
      const emptyArray = data.data.data.map(() => false);
      setArrayOfShow(emptyArray);
    }
  }, [data]);

  const handleShow = (index: number) => {
    arrayOfShow[index] = !arrayOfShow[index];
    setArrayOfShow([...arrayOfShow]);
  };

  /* result handler after hit delete route by id API */
  const [resultDeleteSchedule, setResultDeleteSchedule] = React.useState<any | undefined>(undefined);
  /* mutation for delete client from route */
  const { mutate: mutateDeleteSchedule, isLoading: deleteScheduleLoading } = useMutation(api.schedules.deleteById, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log('delete result', res);
      setResultDeleteSchedule(res);
    },
    onError: (err) => {
      console.log('delete error', err);
      setResultDeleteSchedule(err);
    },
  });
  const onDeleteSchedule = (id: number) => {
    mutateDeleteSchedule({
      id,
    });
  };
  // Move a schedule through the steps that can be controlled from this page.
  const { mutate: statusHandler, isLoading: statusLoad } = useMutation(api.schedules.statusHandler, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (res) => {
      console.log('change status result', res);
      setResultDeleteSchedule(res);
    },
    onError: (err) => {
      console.log('delete error', err);
      setResultDeleteSchedule(err);
    },
  });
  const handleStatus = (id: number, status: number | null) => {
    statusHandler({ id, status });
  };

  const onAfterDeleteSchedule = () => {
    setResultDeleteSchedule(undefined);
    refetch().catch((e) => alert(e.message));
  };

  const initValues: MyFormValueType = {
    id: 0,
    vmId: [],
    sendEmail: true,
    sendSMS: true,
  };

  const formik = useFormik({
    initialValues: initValues,

    onSubmit: ((values) => {
    }),
  });

  return {
    resData,
    isLoading,
    onNavigateEditSchedule,
    arrayOfShow,
    handleShow,
    currentPage,
    onNextPage,
    onPreviousPage,
    data,
    resultDeleteSchedule,
    onDeleteSchedule,
    onAfterDeleteSchedule,
    deleteScheduleLoading,
    handleStatus,
    statusLoad,
  };
}

export default useScheduled;
